import { getUniqueString as e, getValidationState as t, hasSlotContent as n, removeClassStyleAttrs as r } from "../../common/utils/index.js";
import { MessagesMixin as i } from "../../common/mixins/input.js";
import { t as a } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import o from "../validation-messages/validation-messages.js";
import { TEXT_SIZE_MODIFIERS as s, TEXT_STRENGTH_MODIFIERS as c } from "../text/text-constants.js";
import l from "../text/text.js";
import { SELECT_SIZE_MODIFIERS as u, SELECT_STATE_MODIFIERS as d } from "./select-menu-constants.js";
import { optionsValidator as f } from "./select-menu-validators.js";
import { Fragment as p, createBlock as m, createCommentVNode as h, createElementBlock as g, createElementVNode as _, createTextVNode as v, createVNode as y, mergeProps as b, normalizeClass as x, normalizeStyle as S, openBlock as C, renderList as w, renderSlot as T, resolveComponent as E, toDisplayString as D, toHandlers as O, warn as k, withCtx as A } from "vue";
//#region components/select_menu/select_menu.vue
var j = {
	compatConfig: { MODE: 3 },
	name: "DtSelectMenu",
	components: {
		DtValidationMessages: o,
		DtText: l
	},
	mixins: [i],
	inheritAttrs: !1,
	props: {
		label: {
			type: String,
			default: ""
		},
		showLabel: {
			type: Boolean,
			default: !0
		},
		description: {
			type: String,
			default: ""
		},
		options: {
			type: Array,
			default: () => [],
			validator: (e) => f(e)
		},
		size: {
			type: [String, Number],
			default: 300,
			validator: (e) => Object.keys(u).includes(String(e))
		},
		labelClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		descriptionClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		selectClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		optionClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		labelChildProps: {
			type: Object,
			default: () => ({})
		},
		descriptionChildProps: {
			type: Object,
			default: () => ({})
		},
		optionChildProps: {
			type: Object,
			default: () => ({})
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		modelValue: {
			type: [String, Number],
			default: ""
		},
		labelSize: {
			type: [String, Number],
			default: null,
			validator: (e) => s.label.includes(String(e))
		},
		labelStrength: {
			type: String,
			default: null,
			validator: (e) => Object.keys(c).includes(e)
		}
	},
	emits: ["update:modelValue"],
	data() {
		return {
			SELECT_SIZE_MODIFIERS: u,
			SELECT_STATE_MODIFIERS: d,
			hasSlotContent: n
		};
	},
	computed: {
		resolvedLabelSize() {
			if (this.labelSize != null) return this.labelSize;
			let e = String(this.size);
			return e === "xl" || e === "500" ? e === "500" ? "400" : "lg" : this.size;
		},
		resolvedDescriptionSize() {
			return {
				100: "xs",
				200: "xs",
				300: "sm",
				400: "sm",
				500: "md",
				xs: "xs",
				sm: "xs",
				md: "sm",
				lg: "sm",
				xl: "md"
			}[String(this.size)] || "sm";
		},
		resolvedDescriptionDensity() {
			let e = String(this.size);
			return e === "xl" || e === "500" ? "300" : void 0;
		},
		selectListeners() {
			return {
				input: () => {},
				change: (e) => this.emitValue(e.target.value, e)
			};
		},
		state() {
			return t(this.formattedMessages);
		},
		selectKey() {
			return e();
		},
		descriptionKey() {
			return `select-${this.selectKey}-description`;
		},
		labelAriaDetails() {
			return this.$slots.description || this.description ? this.descriptionKey : this.$attrs["aria-details"];
		}
	},
	mounted() {
		this.validateOptionsPresence(), this.runValidations();
	},
	beforeUpdate() {
		this.validateOptionsPresence();
	},
	methods: {
		removeClassStyleAttrs: r,
		emitValue(e, t) {
			this.$emit("update:modelValue", e, t);
		},
		getOptionKey(e) {
			return `select-${this.selectKey}-option-${e}`;
		},
		validateOptionsPresence() {
			this.options?.length < 1 && !this.$slots.default && k("Options are expected to be provided via prop or slot", this);
		},
		runValidations() {
			!(this.$slots.label || this.label) && !this.$attrs["aria-label"] && console.info("[Dialtone] A label is required for accessibility. Provide a label prop and use show-label=\"false\" to hide it visually.");
		}
	}
}, M = [
	"aria-label",
	"disabled",
	"value"
], N = ["value"];
function P(e, t, n, r, i, a) {
	let o = E("dt-text"), s = E("dt-validation-messages");
	return C(), g("div", {
		class: x(e.$attrs.class),
		style: S(e.$attrs.style)
	}, [_("label", null, [
		n.showLabel && (i.hasSlotContent(e.$slots.label) || n.label) ? (C(), m(o, b({
			key: 0,
			kind: "label",
			size: a.resolvedLabelSize,
			strength: n.labelStrength,
			tone: "secondary",
			as: "div",
			"aria-details": a.labelAriaDetails,
			class: ["d-select__label-text", n.labelClass]
		}, n.labelChildProps, { "data-qa": "dt-select-label" }), {
			default: A(() => [T(e.$slots, "label", {}, () => [v(D(n.label), 1)])]),
			_: 3
		}, 16, [
			"size",
			"strength",
			"aria-details",
			"class"
		])) : h("", !0),
		i.hasSlotContent(e.$slots.description) || n.description ? (C(), m(o, b({
			key: 1,
			id: a.descriptionKey,
			kind: "body",
			size: a.resolvedDescriptionSize,
			tone: "tertiary",
			density: a.resolvedDescriptionDensity,
			as: "div",
			class: ["d-description", n.descriptionClass]
		}, n.descriptionChildProps, { "data-qa": "dt-select-description" }), {
			default: A(() => [T(e.$slots, "description", {}, () => [v(D(n.description), 1)])]),
			_: 3
		}, 16, [
			"id",
			"size",
			"density",
			"class"
		])) : h("", !0),
		_("div", {
			class: x([
				"d-select",
				i.SELECT_SIZE_MODIFIERS[String(n.size)],
				n.selectClass,
				{ "d-select--disabled": n.disabled }
			]),
			"data-qa": "dt-select-wrapper"
		}, [_("select", b({
			ref: "selectElement",
			class: ["d-select__input", i.SELECT_STATE_MODIFIERS[a.state]],
			"aria-label": !n.showLabel && n.label ? n.label : void 0
		}, a.removeClassStyleAttrs(e.$attrs), {
			"data-qa": "dt-select",
			disabled: n.disabled,
			value: n.modelValue
		}, O(a.selectListeners, !0)), [T(e.$slots, "default", {}, () => [(C(!0), g(p, null, w(n.options, (e) => (C(), g("option", b({
			key: a.getOptionKey(e.value),
			value: e.value,
			class: n.optionClass
		}, { ref_for: !0 }, n.optionChildProps), D(e.label), 17, N))), 128))])], 16, M)], 2)
	]), y(s, b({
		"validation-messages": e.formattedMessages,
		"show-messages": e.showMessages,
		class: e.messagesClass
	}, e.messagesChildProps, { "data-qa": "dt-select-messages" }), null, 16, [
		"validation-messages",
		"show-messages",
		"class"
	])], 6);
}
var F = /* @__PURE__ */ a(j, [["render", P]]);
//#endregion
export { F as default };

//# sourceMappingURL=select-menu.js.map